/**
 * Gift cards del carrito (ENA-1638, contrato en ENA-1730 y en el comentario de backend del 7/10):
 * aplicar y quitar devuelven el carrito; las aplicadas salen de `discountSummary.giftCards`.
 */
import { PaymentRequestError } from '../domain/errors';
import type { GiftCardCart, GiftCardItem } from '../domain/models';
import { translate } from '../i18n';

export const MAX_GIFT_CARDS = 5;

/** Gift cards en uso del carrito, de todos los grupos (tarjeta de regalo y compromiso ticket más bajo). */
export const giftCardsFromCart = (cart: GiftCardCart): GiftCardItem[] =>
  (cart.discountSummary?.giftCards?.groups ?? []).flatMap((group) => group.items ?? []);

/**
 * Mensaje ante una falla al aplicar o quitar una gift card.
 *
 * TODO(ENA-1638) [consultar a backend]: la respuesta solo trae códigos HTTP (400, 401, 403, 404, 500, 503), sin
 * motivo. Los mensajes del diseño (incorrecto, fuera de servicio, límite de uso, vencido) requieren que backend
 * distinga el motivo; hasta entonces 400/404 se muestran como "Código incorrecto".
 */
export const giftCardErrorMessage = (error: unknown): string => {
  if (error instanceof PaymentRequestError) {
    if (error.failure === 'http' && (error.status === 400 || error.status === 404)) {
      return translate('paymentsUI.giftCard.errors.invalid');
    }
    if (error.failure === 'timeout' || error.failure === 'network') {
      return translate('paymentsUI.giftCard.errors.timeout');
    }
  }
  return translate('paymentsUI.giftCard.errors.generic');
};
